module.exports = __webpack_public_path__ + "img/folder.9ac66e29.svg";